import { render, staticRenderFns } from "./uploadData.vue?vue&type=template&id=7b6e24ab"
import script from "./uploadData.vue?vue&type=script&lang=js"
export * from "./uploadData.vue?vue&type=script&lang=js"
import style0 from "./uploadData.vue?vue&type=style&index=0&id=7b6e24ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports